import { render, staticRenderFns } from "./barra_vinculos.vue?vue&type=template&id=6c06819c&"
import script from "./barra_vinculos.vue?vue&type=script&lang=js&"
export * from "./barra_vinculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports